import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { SpanishDatePipe } from '../../../pipe/date.pipe';
import { Buttons, Info } from '@/app/interfaces/projects';
import { ButtonsComponent } from '../../buttons/buttons.component';
import { RiskLevelClassPipe } from '../../../pipe/riskLevelClass.pipe';
import { getProjectSystemCardStateColor } from '../../../utils/card-state-color.utils';
import { mapSystemTypeLabel } from '@/app/shared/mappers/system-type-label.mapper';
import { getTaskFunctionLabel } from '@/app/shared/mappers/task-function-label.mapper';
import { mapRiskLevelLabel } from '@/app/shared/mappers/risk-level-label.mapper';

@Component({
  selector: 'app-system-card',
  standalone: true,
  imports: [DesyAngularModule, CommonModule, SpanishDatePipe, ButtonsComponent, RiskLevelClassPipe],
  templateUrl: './system-card.component.html',
  styleUrls: ['./system-card.component.scss'],
})
export class SystemCardComponent {
  private readonly functionTaskLabel = 'funciones/tareas';
  private readonly systemTypeLabel = 'tipo de sistema';

  @Input() systemName = '';
  @Input() buttons: Buttons[];
  @Input() creationUser = '';
  @Input() creationDate: Date | string = new Date(); // revisar
  @Input() infoCard: Info[] = [];
  @Input() description: string = null;
  @Input() dataPerRow = 3;

  private _state = '';
  @Input() set state(value: string) {
    this._state = value;
    this.color = getProjectSystemCardStateColor(value);
  }
  get state(): string {
    return this._state;
  }

  color = '';

  riskLevelLabel(value: string): string {
    return mapRiskLevelLabel(value);
  }

  isFunctionTasksInfo(info: Info): boolean {
    return info?.label?.trim().toLowerCase() === this.functionTaskLabel && Array.isArray(info.value);
  }

  getFunctionTaskItems(info: Info): string[] {
    if (!Array.isArray(info?.value)) {
      return [];
    }

    return info.value.map((item) => getTaskFunctionLabel(item));
  }

  getInfoValueLabel(info: Info): string {
    if (typeof info.value !== 'string') {
      return '';
    }

    if (this.isSystemTypeInfo(info)) {
      return mapSystemTypeLabel(info.value);
    }

    return info.value;
  }

  shouldUseTwoColumns(items: string[]): boolean {
    return items.length > 6;
  }

  get dataPerRowMdClass(): string {
    switch (this.dataPerRow) {
      case 1:
        return 'md:grid-cols-1';
      case 2:
        return 'md:grid-cols-2';
      case 3:
        return 'md:grid-cols-3';
      case 4:
        return 'md:grid-cols-4';
      case 5:
        return 'md:grid-cols-5';
      case 6:
        return 'md:grid-cols-6';
      default:
        return 'md:grid-cols-3';
    }
  }

  get stateText(): string {
    switch (this.state?.toLowerCase()) {
      case 'desarrollo en subsanación':
      case 'en desarrollo':
      case 'desarrollo solicitado':
      case 'despliegue en subsanación':
      case 'despliegue revisado':
      case 'despliegue solicitado':
      case 'desarrollo validado':
      case 'despliegue validado':
      case 'desarrollo rechazado':
      case 'despliegue rechazado':
      case 'desarrollo finalizado':
      case 'despliegue finalizado':
      case 'desarrollo cancelado':
      case 'despliegue cancelado':
      case 'desarrollado y revisado':
      case 'despliegue desarrollado y revisado':
        return this.state;
      case 'rejected':
        return 'Rechazado';
      case 'pending':
        return 'Solicitado';
      case 'approved':
        return 'Aprobado';
      case 'development':
        return 'En desarrollo';
      case 'operation':
        return 'En funcionamiento';
      case 'correction':
        return 'Pendiente de subsanación';
      case 'finalized':
        return 'Finalizado';
      case 'canceled':
        return 'Cancelado';
      default:
        return null;
    }
  }

  private isSystemTypeInfo(info: Info): boolean {
    return info?.label?.trim().toLowerCase() === this.systemTypeLabel;
  }
}
